import { LegalLayout, H2 } from "@/components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Termini e condizioni" updated="agosto 2025">
      <p>
        I presenti Termini e Condizioni (“Termini”) regolano l'accesso e l'utilizzo del sito <strong>sedio.it</strong> e
        dell'applicazione <strong>Sedio</strong> (l'“Applicazione”). Utilizzando il sito o l'Applicazione accetti i presenti Termini.
      </p>

      <H2>Descrizione del servizio</H2>
      <p>
        Sedio è uno strumento rivolto agli amministratori di condominio che aiuta a gestire la comunicazione con
        condomini e fornitori: raccoglie i messaggi da email, PEC e WhatsApp, li analizza con l'intelligenza artificiale
        per riassumerli e classificarli e trasforma le richieste in pratiche e attività. L'utente mantiene sempre il
        controllo finale: nessuna comunicazione viene inviata senza la sua approvazione.
      </p>

      <H2>Utilizzo consentito</H2>
      <p>
        Ti impegni a utilizzare il servizio in conformità alla legge e a non usarlo per scopi illeciti, per violare diritti
        di terzi o per inviare comunicazioni non autorizzate. Sei responsabile della veridicità dei dati inseriti e della
        gestione delle credenziali di accesso.
      </p>

      <H2>Account e accessi collegati</H2>
      <p>
        Alcune funzionalità richiedono il collegamento di account di terze parti (ad esempio Google). Collegando tali
        account autorizzi Sedio ad accedere ai dati necessari, come descritto nell'Informativa sulla privacy. Puoi revocare
        l'accesso in qualsiasi momento.
      </p>

      <H2>Ruolo dell'intelligenza artificiale</H2>
      <p>
        I contenuti generati dall'intelligenza artificiale sono proposte di supporto e possono contenere imprecisioni.
        Spetta all'utente verificarli e approvarli prima dell'invio o dell'utilizzo. Sedio non sostituisce la valutazione
        professionale dell'amministratore.
      </p>

      <H2>Proprietà intellettuale</H2>
      <p>Il sito, l'Applicazione, i marchi e i contenuti (esclusi i dati dell'utente) sono di proprietà di Sedio o dei rispettivi titolari e sono protetti dalla legge.</p>

      <H2>Limitazione di responsabilità</H2>
      <p>
        Il servizio è fornito “così com'è”. Nei limiti consentiti dalla legge, Sedio non risponde di danni indiretti o
        conseguenti derivanti dall'uso o dal mancato uso del servizio. Nulla nei presenti Termini limita le responsabilità
        che non possono essere escluse per legge.
      </p>

      <H2>Modifiche al servizio e ai Termini</H2>
      <p>Possiamo modificare o sospendere il servizio e aggiornare i presenti Termini. Le modifiche saranno pubblicate su questa pagina con la relativa data di aggiornamento.</p>

      <H2>Legge applicabile</H2>
      <p>I presenti Termini sono regolati dalla legge italiana. Per eventuali controversie sarà competente il foro del luogo di residenza o domicilio del consumatore, ove applicabile.</p>

      <H2>Contatti</H2>
      <p>Per domande sui presenti Termini contattaci tramite il modulo presente sul sito nella sezione “Contatti”.</p>
    </LegalLayout>
  );
}
